// Костыль, потому что не возвращаются данные из api коров, если в системном списке нет элементов
const blacklistScrollLocalId = '00000000-0000-0000-0000-000000000001';
const partnersCarriersLocalId = '00000000-0000-0000-0000-000000000002';
const partnersCargoOwnerLocalId = '00000000-0000-0000-0000-000000000003';
export const defaultScrolls = {
    'ru': [
        {
            'id': blacklistScrollLocalId,
            'default': true,
            'fixed':true,
            'name':'"Черный" список',
            'type':2,
            'description':'Фирмы, с которыми вы не хотите работать и контактировать',
            'personal':false,
            'emoji':':no_entry:',
            'elements': []
        },
        {
            'id': partnersCarriersLocalId,
            'fixed':true,
            'default': true,
            'name':'Партнёры-перевозчики',
            'type':1,
            'description':'Фирмы, которым вы готовы доверить перевозку своих грузов',
            'personal':false,
            'emoji':':+1:',
            'elements': []
        },
        {
            'id': partnersCargoOwnerLocalId,
            'fixed':true,
            'default': true,
            'name':'Партнёры-грузоотправители',
            'type':1,
            'description':'Фирмы, которым вы перевозили или готовы перевезти грузы',
            'personal':false,
            'emoji':':+1:',
            'elements': []
        }
    ],
    'en': [
        {
            'id': blacklistScrollLocalId,
            'default': true,
            'fixed':true,
            'name':'Blacklist',
            'type':2,
            'description':'You do not want to work and communicate with such companies',
            'personal':false,
            'emoji':':no_entry:',
            'elements': []
        },
        {
            'id': partnersCarriersLocalId,
            'fixed':true,
            'default': true,
            'name':'Partners - carriers',
            'type':1,
            'description':'The companies which you are ready to trust cargo delivery',
            'personal':false,
            'emoji':':+1:',
            'elements': []
        },
        {
            'id': partnersCargoOwnerLocalId,
            'fixed':true,
            'default': true,
            'name':'Partners - shippers',
            'type':1,
            'description':'Companies for which you have delivered cargo or you are ready to do it',
            'personal':false,
            'emoji':':+1:',
            'elements': []
        }
    ]
};
//лимит на стороне сервиса списков фирм по кол-ву переданных объектов в запрос scrolls/v1/firms/elements
export const scrollsInviteDataLimit = 1000;
